import { Directive, HostListener } from '@angular/core';

/**------------------------------------------------------
 * Numeric only
 * ----------
 * Accepts only Numeric values in the input field
 * Created this Directive for Phone number input fields
 *
 * Example:
 * --------
 * 	<input type="text" [appNumericOnly] />
 */
@Directive({
    selector: '[ngNumericOnly]',
    standalone: false
})
export class NgNumericOnlyDirective {

	// Remove the character except numbers
	@HostListener('input', ['$event'])
	public onInput(event: Event): void {

		//0 - get the targeted element
		const input: HTMLInputElement = event.target as HTMLInputElement;

		//1 - remove non-digit characters
		input.value = input.value.replace(/\D/g, '');
	}
}
